import { render, staticRenderFns } from "./IosGameStrategy.vue?vue&type=template&id=a735ada4&scoped=true&"
import script from "./IosGameStrategy.vue?vue&type=script&lang=js&"
export * from "./IosGameStrategy.vue?vue&type=script&lang=js&"
import style0 from "./IosGameStrategy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./IosGameStrategy.vue?vue&type=style&index=1&id=a735ada4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a735ada4",
  null
  
)

export default component.exports